<template>
    <div class="wrapper-body flex-1">
        <ListCorrespondences :nodeId="nodeId" />
    </div>
</template>

<script>
    import ListCorrespondences from '@/components/ListCorrespondences.vue';

	export default {
		name: 'SignedView',
        components: { ListCorrespondences },
        data () 
        {
            return {
                nodeId: 2,
            }
        },
        mounted () 
        {
            this.nodeId = 2
        },
	}
</script>